module.exports = __webpack_public_path__ + "img/img14.09a572f9.svg";